import { memo } from "react";
import { useSelector } from 'react-redux'
import AuthApp from '@mods/userManagement/auth/routes';
import Main from "./Main";
import { AppProvider } from "../utils/context";
import AppLocale from '../lngProvider/index';
import { IntlProvider } from "react-intl";

const App = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  const currentAppLocale = AppLocale["en"]

  return (
    <AppProvider>
      <IntlProvider locale="en" messages={ currentAppLocale.messages }>
        { authUser ? <Main /> : <AuthApp /> }
      </IntlProvider>
    </AppProvider>
  );
}

export default memo(App);
